<template>
  <section class="form-section">
    <h3 v-if="title">{{ title }}</h3>

    <div class="row p-2 mb-3" :style="containerStyle" :class="classes">
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: "FormSection",

  props: {
    title: {
      type: String,
      default: "",
    },
    classes: {
      type: String,
      default: "",
    },
  },

  computed: {
    containerStyle() {
      return {
        border: "1px solid #c7c6c6",
        borderRadius: "5px",
      };
    },
  },
};
</script>
